export enum MeritBudgetResponsibilityType {
  DirectResponsibility,
  TotalResponsibility
}
